import {request, history} from '@umijs/max';
import dayjs from "dayjs";
import {getHostToken, isMicroApp} from '@/qiankun';

export function getAuthHeader() {
    if (isMicroApp) {
        return {Token: getHostToken() || '', platform: 'new'};
    }
    const accessToken = localStorage.getItem('TMF_ACCESS_TOKEN');
    if (accessToken) {
        const token = JSON.parse(accessToken);
        return {Token: `${token.token || token.accessToken}`, platform: 'new'};
    }
    return {Token: '', platform: 'new'};
}


export function getCurrentUser() {
    const accessToken = localStorage.getItem('TMF_ACCESS_TOKEN');
    if (accessToken) {
        return JSON.parse(accessToken);
    }
    localStorage.clear();
    history.push('/login');
}


export async function download(url: string, params: any, filename: string) {
    const response = await request<any>(url, {
        headers: getAuthHeader(),
        method: 'GET',
        params,
        responseType: 'blob',
    });
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(response);
    a.download = `${filename}-${dayjs().format('YYYYMMDDHHmmss')}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(response);
}

export function getImageUploadUrlAndName(filePath: string, filename?: string) {
    return `${BASE_URL}/api/upload?filepath=${filePath}&filename=${filename}`;
}

export function getImageUploadUrl(filePath: string) {
    const filename = '';
    return `${BASE_URL}/api/upload?filepath=${filePath}&filename=${filename}`;
}

export function getImageUploadUrlToLocal() {
    return `${BASE_URL}/api/upload/local`;
}

export function getUploadUrl(relativePath: string) {
    return `${BASE_URL}/api/${
        relativePath.startsWith('/') ? relativePath.replace('/', '') : relativePath
    }`;
}

export function getEditorUploadUrl() {
    const konsoleToken = localStorage.getItem('konsole-token');
    if (konsoleToken) {
        const token = JSON.parse(konsoleToken);
        return `${BASE_URL}/api/upload/editor?accessToken=${token.accessToken}`;
    }
    return undefined;
}

export function logout() {
    if (isMicroApp) {
        window.location.assign('/user/apps');
        return;
    }
    localStorage.clear();
    window.open(`${AUTH_URL}`, '_self');
}
